import { useState, useEffect } from "react";
import Axios from "axios";

const UseOrderDetail = (url) => {
  const [data, setData] = useState([]);
  const userToken = localStorage.getItem('userToken');
  useEffect(() => {
    Axios.get(url,{
       headers: { 'Authorization': 'Bearer '+userToken }
    }).then((response)=>{
      if(response.data){
        setData(response.data);
      }
    }).catch((error) => {
      console.log(error)
    });
  }, [url,userToken]);

  return [data];
};

export default UseOrderDetail;